module.exports = __webpack_public_path__ + "static/img/push-msg-icon.fdaed998.svg";